var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_d6d52da6"]},_vm.$listeners),[_c('cube-slider',{attrs:{"step":(5)},on:{"change":(e)=>_vm.__invoke(e, [["handleChange"]]),"changing":(e)=>_vm.__invoke(e, [["handleChanging"]])}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }